// extracted by mini-css-extract-plugin
module.exports = {"fullheight":"VideoPlayer_fullheight__W9Vaz","fullwidth":"VideoPlayer_fullwidth__w19cE"};